import ReceiveTransferMainPage from "./main.container";

export default ReceiveTransferMainPage;
